
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

import { ROUTES } from '../../constants/routes';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to={ROUTES.HOME} className="logo-section">
            <img src="/logos/logo_color_transparente.png" alt="ProCam360 Logo" className="logo" />
            <span className="slogan">Tu opción en cabinas 360</span>
          </Link>

          <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
            <ul>
              <li><Link to={ROUTES.HOME} className={isActive(ROUTES.HOME) ? 'active' : ''}>Inicio</Link></li>
              <li><Link to={ROUTES.SERVICES} className={isActive(ROUTES.SERVICES) ? 'active' : ''}>Servicios</Link></li>
              <li><Link to={ROUTES.PORTFOLIO} className={isActive(ROUTES.PORTFOLIO) ? 'active' : ''}>Portafolio</Link></li>
              <li><Link to={ROUTES.CONTACT} className={isActive(ROUTES.CONTACT) ? 'active' : ''}>Contacto</Link></li>
            </ul>
          </nav>

          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
